/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

export const getDefinitionAudioResultSchema = z.object({
  audioUrl: z.string(),
});

export type IGetDefinitionAudioResult = z.infer<typeof getDefinitionAudioResultSchema>;

export const getDefinitionAudioResponseSchema = createApiResponseSchema(
  getDefinitionAudioResultSchema,
) as z.ZodSchema<IAPI<IGetDefinitionAudioResult>>;

export type IGetDefinitionAudioResponse = IAPI<IGetDefinitionAudioResult>;
